import React, { memo } from 'react'
import { isDesktopSafari, isInternetExplorer } from '../../common/src/helpers/platformHelper'
import { TimeTextField } from '../textFields/TimeTextField'
import { TimeInput } from './TimeInput'

export const SafeTimeInput = memo(props => {
  const Component = isDesktopSafari() || isInternetExplorer() ? TimeTextField : TimeInput
  return <Component {...props} />
})
